// import React, { useState } from "react";
// import styles from "../styles/UlcPremiumCalculator.module.css";
// import styles1 from "../styles/UlcPremium.module.css";
// import SchemeHolderForm from "../components/SchemeHolderForm";
// import IndividualPlotOwnerForm from "../components/IndividualPlotOwnerForm";
// import GovtNomineeFlatForm from "../components/GovtNomineeFlatForm";
// import { useNavigate } from "react-router-dom";
// import { FaArrowLeft } from "react-icons/fa";

// const UlcPremium = () => {
//   const [activeTab, setActiveTab] = useState("schemeHolder");
//   const navigate = useNavigate();
//   const [converterType, setConverterType] = useState("ULC Premium");

//   const handleBack = () => {
//     navigate(-1);
//   };

//   const handleDropdownChange = (e) => {
//     const selected = e.target.value;
//     setConverterType(selected);
//     const pathMap = {
//       "Area Convertor": "/area-convertor",
//       "Built-up Area Calculator": "/built-up-area-calculator",
//       "Development Charges": "/development-charges",
//       "Premium for Ancillary FSI": "/ancillary-fsi",
//       "⁠Premium for Premium FSI": "/premium-fsi",
//       "ULC Premium": "/ulc-premium",
//     };
//     if (pathMap[selected]) navigate(pathMap[selected]);
//   };

//   const renderForm = () => {
//     switch (activeTab) {
//       case "schemeHolder":
//         return <SchemeHolderForm />;
//       case "individualPlot":
//         return <IndividualPlotOwnerForm />;
//       case "govtNominee":
//         return <GovtNomineeFlatForm />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className={styles1.UlcPremium_container}>
//       <div className={styles1.UlcPremium_header}>
//         <button className={styles1.UlcPremium_backButton} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>
//         <h2 className={styles1.UlcPremium_title}>Conversion Calculator</h2>
//       </div>

//       <div className={styles1.UlcPremium_dropdownContainer}>
//         <select
//           value={converterType}
//           onChange={handleDropdownChange}
//           className={styles1.UlcPremium_mainDropdown}
//         >
//           <option>Area Convertor</option>
//           <option>Built-up Area Calculator</option>
//           <option>Development Charges</option>
//           <option>Premium for Ancillary FSI</option>
//           <option>⁠Premium for Premium FSI</option>
//           <option>ULC Premium</option>
//         </select>
//       </div>

//       <div className={styles.calculatorULC_subHeader}>
//         Excess Exempted Lands Premium Calculator
//       </div>

//       <div className={styles.calculatorULC_tabs}>
//         <button
//           className={`${styles.calculatorULC_tabButton} ${
//             activeTab === "schemeHolder" ? styles.calculatorULC_activeTab : ""
//           }`}
//           onClick={() => setActiveTab("schemeHolder")}
//         >
//           Scheme Holder
//         </button>
//         <button
//           className={`${styles.calculatorULC_tabButton} ${
//             activeTab === "individualPlot" ? styles.calculatorULC_activeTab : ""
//           }`}
//           onClick={() => setActiveTab("individualPlot")}
//         >
//           Individual Plot Owner
//         </button>
//         <button
//           className={`${styles.calculatorULC_tabButton} ${
//             activeTab === "govtNominee" ? styles.calculatorULC_activeTab : ""
//           }`}
//           onClick={() => setActiveTab("govtNominee")}
//         >
//           Government Nominee Flat Re-sale
//         </button>
//       </div>

//       <div className={styles.calculatorULC_formSection}>{renderForm()}</div>
//     </div>
//   );
// };

// export default UlcPremium;






import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  Layers, 
  Users, 
  User, 
  Building, 
  ShieldCheck,
  ChevronRight,
  Info
} from "lucide-react";

// Sub-form components (Assumed existing in your project)
import SchemeHolderForm from "../components/SchemeHolderForm";
import IndividualPlotOwnerForm from "../components/IndividualPlotOwnerForm";
import GovtNomineeFlatForm from "../components/GovtNomineeFlatForm";

const UlcPremium = () => {
  const [activeTab, setActiveTab] = useState("schemeHolder");
  const [converterType, setConverterType] = useState("ULC Premium");
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  const renderForm = () => {
    switch (activeTab) {
      case "schemeHolder": return <SchemeHolderForm />;
      case "individualPlot": return <IndividualPlotOwnerForm />;
      case "govtNominee": return <GovtNomineeFlatForm />;
      default: return null;
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 pb-20">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button onClick={handleBack} className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600">
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">TPH Calc</h2>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 mt-10">
        {/* --- TOOL NAVIGATOR --- */}
        <div className="relative mb-10">
          <Layers className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500 z-10" size={18} />
          <select
            value={converterType}
            onChange={handleDropdownChange}
            className="w-full bg-white border border-slate-300 rounded-2xl py-5 pl-12 pr-4 font-bold text-slate-800 appearance-none shadow-md focus:outline-none ring-1 ring-slate-100"
          >
            <option>Area Convertor</option>
            <option>Built-up Area Calculator</option>
            <option>Development Charges</option>
            <option>Premium for Ancillary FSI</option>
            <option>⁠Premium for Premium FSI</option>
            <option>ULC Premium</option>
          </select>
          <ChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" size={18} />
        </div>

        {/* --- MAIN CARD --- */}
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/40 ring-1 ring-slate-200 overflow-hidden">
          <div className="p-8 bg-[#111827] text-white flex justify-between items-center">
            <div>
              <h3 className="text-xl font-black tracking-tight">ULC Premium</h3>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">Excess Exempted Lands</p>
            </div>
            <div className="w-10 h-10 bg-orange-600 rounded-xl flex items-center justify-center shadow-lg shadow-orange-900/20">
              <ShieldCheck size={20} />
            </div>
          </div>

          {/* TABS SECTION */}
          <div className="bg-slate-50 p-2 flex flex-wrap gap-1 border-b border-slate-100">
            {[
              { id: "schemeHolder", label: "Scheme Holder", icon: <Users size={16} /> },
              { id: "individualPlot", label: "Plot Owner", icon: <User size={16} /> },
              { id: "govtNominee", label: "Govt Nominee", icon: <Building size={16} /> }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl font-bold text-xs transition-all ${
                  activeTab === tab.id 
                    ? "bg-white text-orange-600 shadow-sm ring-1 ring-slate-200" 
                    : "text-slate-500 hover:bg-slate-100"
                }`}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </div>

          {/* FORM CONTENT */}
          <div className="p-8">
            <div className="bg-orange-50/50 p-4 rounded-xl border border-orange-100/50 mb-8">
               <p className="text-[11px] text-orange-700 font-black flex items-center gap-2">
                 <Info size={14} /> 
                 {activeTab === "schemeHolder" && "Calculating premium for Section 20 exempted schemes."}
                 {activeTab === "individualPlot" && "Individual plot regularisation premium rules applied."}
                 {activeTab === "govtNominee" && "Processing premium for government quota flat re-sales."}
               </p>
            </div>

            {/* Logical Form Rendering */}
            <div className="min-h-[300px]">
              {renderForm()}
            </div>
          </div>
        </div>

        <p className="text-center mt-8 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel Intelligence Platform • Pune, Maharashtra
        </p>
      </main>
    </div>
  );
};

export default UlcPremium;